<template>
  <Modal 
    class="week-modal"
    width="344px"
    :show="show" 
    @close="close"
    :closeOnClickLayer="true"
  >
    <!-- <template v-if="step === 0">
      <div slot="content">
        <p class="desc">InfoQ 每周精要将以邮件的形式发放至您的邮箱</p>
        <div class="email-wrap">
          <transition name="fade">
            <div class="success" v-if="success">{{success}}</div>
          </transition>
          <input class="input email-input" type="text" placeholder="请输入邮箱" v-model="currentValue" @blur="validate">
          <transition name="fade">
            <div class="error" v-if="error">{{error}}</div>
          </transition>
        </div>
        <transition>
          <div class="captcha-wrap" v-if="showCaptcha">
            <div class="captcha-input">
              <input type="text" :disabled="captchaDisabled" placeholder="请输入图形验证码" v-model="captchaValue" @blur="validateCaptcha">
              <transition name="fade">
                <div class="error" v-if="captchaError">{{captchaError}}</div>
              </transition>
            </div>
            <div class="captcha" @click="refreshCaptcha">
              <img :src="captchaUrl" alt="">
            </div>
          </div>
        </transition>
        <div class="code-wrap">
          <input class="input" type="text" placeholder="请输入验证码" v-model="codeValue" @blur="validateCode">
          <span class="code-btn" @click="sendSms" :class="{sending: sending}">{{sending ? time + ' 秒' : '获取验证码'}}</span>
          <transition name="fade">
            <div class="error" v-if="codeError">{{codeError}}</div>
          </transition>
        </div>
      </div>
      <div slot="footer">
        <gkButton class="sub-btn" color="blue" size="big" :useLock="true" @click="submit">确认订阅</gkButton>
      </div>
    </template>
    <template v-if="step === 1">
      <div slot="content" class="sub-success">
        <div class="icon-success">
          <img src="../../assets/img/landing/register-success.png" alt="">
        </div>
        <h3>订阅成功</h3>
        <p class="desc">InfoQ 每周精要将以邮件的形式发放至您的邮箱</p>
      </div>
    </template> -->
    <div class="week-modal-body" slot="content">
      <ComWeekly class="landing-weekly" @close="close">
        <div slot="link"></div>
      </ComWeekly>
      <span class="close-btn iconfont" @click="close">&#xe60a;</span>
    </div>
  </Modal>
</template>
<script>
import VueTypes from 'vue-types'
import gkButton from 'gkui/button'
import ComWeekly from '../weekly/Weekly'

import Modal from './Modal'

import HomeService from '../../service/home.service'
export default {
  name: 'sub-email-modal',
  components: {
    gkButton,
    Modal,
    ComWeekly
  },
  props: {
    show: VueTypes.bool.def(false)
  },
  data () {
    return {
      showCaptcha: false,
      currentValue: '',
      codeValue: '',
      captchaValue: '',
      error: false,
      codeError: '',
      captchaError: '',
      captchaDisabled: false,
      success: '',
      sending: false,
      step: 0,
      time: 60,
      delayInputTime: [],
      guid: Date.now()
    }
  },
  computed: {
    captchaUrl () {
      return '/public/v1/user/createCaptch' + '?' + this.guid
    }
  },
  created () {
  },
  methods: {
    close () {
      this.currentValue = ''
      this.captchaValue = ''
      this.codeValue = ''
      this.captchaError = ''
      this.codeError = ''
      this.error = ''
      this.sending = false
      this.showCaptcha = false
      this.captchaDisabled = false
      this.time = 60
      this.$emit('close')
    },
    validate () {
      const regEmail = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/
      if (!regEmail.test(this.currentValue)) {
        this.error = '邮箱格式错误'
      } else {
        this.error = ''
      }
    },
    validateCode () {
      const regCode = /^\S{6}$/
      if (!regCode.test(this.codeValue)) {
        this.codeError = '验证码格式错误'
      } else {
        this.codeError = ''
      }
    },
    validateCaptcha () {
      const regCaptcha = /^\S{4}$/
      if (!regCaptcha.test(this.captchaValue)) {
        this.captchaError = '验证码格式错误'
      } else {
        this.captchaError = ''
      }
    },
    sendSms () {
      if (this.error || this.captchaError) {
        return
      }
      if (!this.currentValue) {
        this.error = '请输入邮箱'
        return
      }
      if (this.showCaptcha && !this.captchaValue) {
        this.captchaError = '请输入图形验证码'
        return
      }
      if (!this.sending) {
        this.sending = true
        this.loopTime()
        // 发送验证码
        HomeService.sendSubWeekEmailCode({email: this.currentValue, code: this.captchaValue}).then(res => {
          if (res) {
            if (this.showCaptcha) {
              this.captchaDisabled = true
            }
            this.success = '验证码发送成功'
            setTimeout(() => {
              this.success = ''
            }, 3000)
          }
        }).catch(err => {
          let code = err.code.toString()
          if (code === '-4002' || code === '-4003' || code === '-4004') {
            if (!this.showCaptcha) {
              this.showCaptcha = true
            } else {
              this.captchaDisabled = false
              this.captchaError = err.msg
              this.refreshCaptcha()
            }
            this.sending = false
            this.time = 60
            return
          }
          this.codeError = err.msg
          this.sending = false
          this.time = 60
        })
      }
    },
    loopTime () {
      if (!this.sending) {
        this.time = 60

        return
      }

      setTimeout(() => {
        this.time--

        if (this.time > 0) {
          this.loopTime()
        } else {
          this.sending = false
          this.time = 60
        }
      }, 1000)
    },
    submit ({clear}) {
      if (!this.currentValue) {
        this.error = '请输入邮箱'
        clear && clear()
        return
      }
      if (!this.codeValue) {
        this.codeError = '请输入验证码'
        clear && clear()
        return
      }
      if (this.codeError) {
        clear && clear()
        return
      }

      if (!this.error && !this.codeError) {
        HomeService.subWeek({email: this.currentValue, code: this.codeValue})
          .then(res => {
            this.step ++
            // 不改变订阅状态了，这两行没用了
            // this.isSub = true
            // this.$emit('changeSub', true)
            this.tips = true

            // setTimeout(() => {
            //   this.close()
            // }, 1000)
          })
          .catch(err => {
            clear && clear()
            console.log(err)
            let code = err.code.toString()
            if (code === '-4002' || code === '-4003' || code === '-4004') {
              this.captchaError = err.msg
            }
            this.codeError = err.msg
          })
      }
    },
    /**
     * 刷新图形验证码
     */
    refreshCaptcha () {
      this.guid = Date.now()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";
.week-modal ::v-deep .content {
  // padding: 50px;
}

.week-modal-body {
  position: relative;
  width: 100%;

  & .close-btn {
    position: absolute; top: -10px; right: -10px; z-index: 20;
    width: 20px; height: 20px;
    cursor: pointer;
    user-select: none;
  }
}
.desc {
  margin: 35px 0;
  @extend %font12;
  text-align: center;
  color: $lightBlack;
}
.sub-btn {
  width: 137px; height: 37px;
}

.input {
  width: 100%;
  padding: 14px 0;
  @include lineFont(16);
  text-align: left;
  border: none;
  border-bottom: 1px solid $borderGray;

  &[disabled] {
    user-select: none;
    cursor: not-allowed;
  }
}
.email-wrap {
  position: relative;
  margin-bottom: 20px;
  
  & .success {
    position: absolute; top: -10px; left: 0;
    height: 20px;
    color: #17B04B;
    @extend %font12;
  }
}

.captcha-wrap {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 15px;
  border-bottom: 1px solid $borderGray;

  & .captcha-input {
    position: relative;
    flex: 1;

    & input {
      width: 100%;
      @include lineFont(16);
      background:transparent;
      border: 0;
      outline: none;

      &[disabled] {
        user-select: none;
        cursor: not-allowed;
      }
    }

    & .error {
      position: absolute; z-index: 100; left: 0; bottom: -27px;
    }
  }
  
  & .captcha {
    width: 100px; height: 100%;
    cursor: pointer;

    & img {
      width: 100%; height: 100%;
    }
  }
}

.code-wrap {
  position: relative;
  margin-bottom: 56px;

  & .code-btn {
    position:absolute; top: 0; right: 0;
    line-height: 53px;
    font-size: 14px;
    color: #1F6BB5;
    cursor: pointer;
    user-select: none;
  }

  & .sending {
    color: #8A8A8A;
    cursor: not-allowed;
    pointer-events: none;
  }
}
.captcha-input,
.email-wrap,
.code-wrap {
  & .error{
    line-height: 22px;
    @include font(12, 400);
    color: #ff3232;
  }
}
.email-wrap,
.code-wrap {
  & .error {
    position: absolute; z-index: 100; left:0; bottom: -20px;
  }
}


.result-container {
  height: 33px;

  & .error,
  & .tips {
    line-height: 22px;
    @include font(12, 400);
    text-align: center;
    color: #ff3232;
  }

  & .tips {
    line-height: 32px;
    @include font(14, 400);
    color: $blue;
  }
}
.sub-success {
  & .icon-success {
    width: 58px; height: 58px;
    margin: 65px auto 20px;

    & img {
      width: 100%; height: 100%;
    }
  }
  h3 {
    @include lineFont(16, 400);
    text-align: center;
  }
  p.desc {
    margin-top: 13px;
  }
}

@media screen and (max-width: 414px) {
  .week-modal ::v-deep .content {
    width: 330px!important;
    // padding: 30px;
  }
}
</style>
